import { render } from "./paymentsetmodal.vue?vue&type=template&id=0fa1955b"
import script from "./paymentsetmodal.vue?vue&type=script&lang=js"
export * from "./paymentsetmodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__